export default "__VITE_ASSET__SsJ8FmMG__"